/* eslint-disable */
import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Polyline } from '@react-google-maps/api'
import React, { useEffect, useRef, useState } from 'react'
import ApiService from '../../../../ApiService.js'
import { useStates } from '../../../../StateProvider.js'
import { TRIP_STOPS_URL } from '../../../../constants.js'
import { useEmulatorStore } from '../../../../stores/emulator/store.tsx'

export function PathComponent({ mapRef }) {
  const { showToast } = useStates()
  const pathTraveledRef = useRef(useEmulatorStore.getState().pathTraveled)
  const pathNotTraveledRef = useRef(useEmulatorStore.getState().pathNotTraveled)

  let defaultPathTraveledRef = useEmulatorStore(
    (state) => state.defaultPathTraveled
  )
  let alternativePathTraveledRef = useEmulatorStore(
    (state) => state.alternativePathTraveled
  )

  /* Select route from dropdown */
  let selectRoutePathIndex = useEmulatorStore((state) => state.pathIndex)

  const pathTraveledPolylineRef = useRef(null)
  const pathNotTraveledPolylineRef = useRef(null)

  const [showCreateStop, setShowCreateStop] = useState(false)

  const [createStops, setCreateStops] = useState({
    tripPoints: '',
    emulatorId: ''
  })

  const [routeIndex, setRouteIndex] = useState(-1)

  const connectedEmulatorRef = useRef(
    useEmulatorStore.getState().connectedEmulator
  )

  useEffect(() => {
    setRouteIndex(selectRoutePathIndex)
  }, [selectRoutePathIndex])

  useEffect(() => {
    if (alternativePathTraveledRef[0] !== 0) {
      if (!mapRef.current || !alternativePathTraveledRef?.length) return

      const bounds = new window.google.maps.LatLngBounds()

      alternativePathTraveledRef.forEach((route) => {
        route.forEach((point) => {
          bounds.extend(new window.google.maps.LatLng(point.lat, point.lng))
        })
      })

      mapRef.current.fitBounds(bounds)
    }
  }, [alternativePathTraveledRef])

  // const [newRoutePath, setNewRoutePath] = useState()

  // useEffect(() => {
  //   console.log('1:', RoutesPath)
  //   console.log('2:', pathNotTraveledRef)

  //   const responseRoutes = RoutesPath?.routes?.filter(
  //     (item) => item.summary === 'NH 709B'
  //   )

  //   const responseRoutesUpdated = responseRoutes[0].legs[0].steps
  //   console.log('3:', responseRoutes[0].legs[0].steps)

  //   const routesResponse = responseRoutesUpdated.map((item, index) => ({
  //     bearing: 0,
  //     distance: item.distance.value,
  //     lat: item.end_location.lat,
  //     lng: item.end_location.lng,
  //     tripPointIndex: index
  //   }))

  //   console.log('4:', routesResponse)
  //   setNewRoutePath(routesResponse)
  // }, [])

  const handleClose = () => {
    setShowCreateStop(false)
  }

  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.connectedEmulator,
        (connectedEmulator) => {
          connectedEmulatorRef.current = connectedEmulator
        }
      ),
    []
  )

  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.pathTraveled,
        (pathTraveled) => {
          pathTraveledRef.current = pathTraveled
          if (pathTraveled === null || pathTraveled === undefined) {
            // reset the path
            pathTraveledPolylineRef.current?.setPath([])
            // update the path
            pathTraveledRef.current = []
            return
          }
          if (pathTraveledPolylineRef.current) {
            pathTraveledPolylineRef.current?.setPath(pathTraveled)
          }
        }
      ),
    []
  )

  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.pathNotTraveled,
        (pathNotTraveled) => {
          pathNotTraveledRef.current = pathNotTraveled
          if (pathNotTraveled === null || pathNotTraveled === undefined) {
            // reset the path
            pathNotTraveledPolylineRef.current?.setPath([])
            // update the path
            pathNotTraveledRef.current = []
            return
          }
          if (pathNotTraveledPolylineRef.current) {
            pathNotTraveledPolylineRef.current?.setPath(pathNotTraveled)
          }
        }
      ),
    []
  )

  function onPolyLineClickTraveled(e) {
    if (
      connectedEmulatorRef.current === null ||
      connectedEmulatorRef.current === undefined ||
      pathTraveledRef.current === null ||
      pathTraveledRef.current === undefined
    ) {
      showToast(
        'Something went wrong! Please refresh if this keeps happening',
        'error'
      )
      return
    }
    const emulatorId = connectedEmulatorRef.current.id
    const clickedLatLng = { lat: e.latLng.lat(), lng: e.latLng.lng() }

    const findClosestPointIndex = (path) => {
      return path.reduce((closestIndex, currentLatLng, index) => {
        const d1 =
          Math.pow(currentLatLng.lat - clickedLatLng.lat, 2) +
          Math.pow(currentLatLng.lng - clickedLatLng.lng, 2)
        const d2 =
          closestIndex === -1
            ? Infinity
            : Math.pow(path[closestIndex].lat - clickedLatLng.lat, 2) +
              Math.pow(path[closestIndex].lng - clickedLatLng.lng, 2)
        return d1 < d2 ? index : closestIndex
      }, -1)
    }

    const closestIndexPath = findClosestPointIndex(pathTraveledRef.current)
    if (closestIndexPath && closestIndexPath !== -1) {
      setShowCreateStop(!showCreateStop)
      setCreateStops({
        tripPoints: pathTraveledRef.current[closestIndexPath],
        emulatorId: emulatorId
      })
      // requestNewStopCreation(
      //   pathTraveledRef.current[closestIndexPath],
      //   emulatorId
      // )
    }
  }

  function onPolyLineClickNotTraveled(e) {
    if (
      connectedEmulatorRef.current === null ||
      connectedEmulatorRef.current === undefined ||
      pathNotTraveledRef.current === null ||
      pathNotTraveledRef.current === undefined
    ) {
      showToast(
        'Something went wrong! Please refresh if this keeps happening',
        'error'
      )
      return
    }
    const emulatorId = connectedEmulatorRef.current.id
    const clickedLatLng = { lat: e.latLng.lat(), lng: e.latLng.lng() }

    const findClosestPointIndex = (path) => {
      return path.reduce((closestIndex, currentLatLng, index) => {
        const d1 =
          Math.pow(currentLatLng.lat - clickedLatLng.lat, 2) +
          Math.pow(currentLatLng.lng - clickedLatLng.lng, 2)
        const d2 =
          closestIndex === -1
            ? Infinity
            : Math.pow(path[closestIndex].lat - clickedLatLng.lat, 2) +
              Math.pow(path[closestIndex].lng - clickedLatLng.lng, 2)
        return d1 < d2 ? index : closestIndex
      }, -1)
    }

    const closestIndexPath = findClosestPointIndex(pathNotTraveledRef.current)
    if (closestIndexPath && closestIndexPath !== -1) {
      setShowCreateStop(!showCreateStop)
      setCreateStops({
        tripPoints: pathNotTraveledRef.current[closestIndexPath],
        emulatorId: emulatorId
      })
      // requestNewStopCreation(
      //   pathNotTraveledRef.current[closestIndexPath],
      //   emulatorId
      // )
    }
  }

  async function requestNewStopCreation(tripPoint, emulatorId) {
    // setShowCreateStop
    // confirm from window alert
    // const confirm = window.confirm('Create a new Stop at this location?')
    // if (!confirm) {
    //   return
    // }

    const token = localStorage.getItem('token')
    showToast('Creating Stop...', 'info')
    const { success, error } = await ApiService.makeApiCall(
      TRIP_STOPS_URL,
      'POST',
      tripPoint,
      token,
      emulatorId
    )
    if (success) {
      showToast('Stop created!', 'success')
      // setTripData(data); NOTE: THIS IS NOT NEEDED, THE SSE SHOULD BE ABLE TO RESPOND TO THIS CHANGE WITHIN 500 ms
    } else {
      showToast(error, 'error')
      console.error('Error creating Stop: ', error)
    }
    setShowCreateStop(false)
  }

  return (
    <>
      <Polyline
        onLoad={(polyline) => (pathTraveledPolylineRef.current = polyline)}
        path={pathTraveledRef.current}
        // path={newRoutePath}
        options={{
          strokeColor: '#0b3d91', // Dark Blue
          strokeOpacity: 1.0,
          strokeWeight: 6, // Thickness of the line
          defaultVisible: true
        }}
        onClick={onPolyLineClickTraveled}
      />

      {/* default of path route */}
      {routeIndex === 0 &&
        defaultPathTraveledRef !== 0 &&
        (pathTraveledRef.current === null ||
          pathNotTraveledRef.current === null ||
          pathTraveledRef.current?.length === 0 ||
          pathNotTraveledRef.current?.length === 0) && (
          <Polyline
            onLoad={(polyline) => {
              console.log('Polyline Loaded:', polyline)
            }}
            path={defaultPathTraveledRef}
            options={{
              strokeColor: '#1976D2',
              strokeWeight: 3,
              strokeOpacity: 1,
              defaultVisible: true
            }}
            onClick={onPolyLineClickTraveled}
          />
        )}

      {/* use map here to iterate over an array */}
      {routeIndex > 0 &&
        alternativePathTraveledRef[0] !== 0 &&
        (pathTraveledRef.current === null ||
          pathNotTraveledRef.current === null ||
          pathTraveledRef.current?.length === 0 ||
          pathNotTraveledRef.current?.length === 0) &&
        alternativePathTraveledRef?.map((route, index) => (
          <Polyline
            key={index}
            onLoad={(polyline) => {
              console.log('Polyline Loaded:', polyline)
            }}
            path={alternativePathTraveledRef[routeIndex - 1]}
            options={{
              strokeColor:
                routeIndex - 1 === 0
                  ? '#388E3C'
                  : routeIndex - 1 === 1
                    ? '#F57C00'
                    : '#7B1FA2',
              strokeWeight: 3,
              strokeOpacity: 1,
              defaultVisible: true
            }}
            onClick={onPolyLineClickTraveled}
          />
        ))}

      {/* To show all the routes */}
      {routeIndex === -1 &&
        defaultPathTraveledRef !== 0 &&
        (pathTraveledRef.current === null ||
          pathNotTraveledRef.current === null ||
          pathTraveledRef.current?.length === 0 ||
          pathNotTraveledRef.current?.length === 0) && (
          <Polyline
            onLoad={(polyline) => {
              console.log('Polyline Loaded:', polyline)
            }}
            path={defaultPathTraveledRef}
            options={{
              strokeColor: '#1976D2',
              strokeWeight: 3,
              strokeOpacity: 1,
              defaultVisible: true
            }}
            onClick={onPolyLineClickTraveled}
          />
        )}

      {routeIndex === -1 &&
        alternativePathTraveledRef[0] !== 0 &&
        (pathTraveledRef.current === null ||
          pathNotTraveledRef.current === null ||
          pathTraveledRef.current?.length === 0 ||
          pathNotTraveledRef.current?.length === 0) &&
        alternativePathTraveledRef?.map((route, index) => (
          <Polyline
            key={index}
            onLoad={(polyline) => {
              console.log('Polyline Loaded:', polyline)
            }}
            path={route}
            options={{
              strokeColor:
                index === 0 ? '#388E3C' : index === 1 ? '#F57C00' : '#7B1FA2',
              strokeWeight: 3,
              strokeOpacity: 1,
              defaultVisible: true
            }}
            onClick={onPolyLineClickTraveled}
          />
        ))}

      {/* PathNotTravelled */}
      <Polyline
        onLoad={(polyline) => (pathNotTraveledPolylineRef.current = polyline)}
        path={pathNotTraveledRef.current}
        // path={newRoutePath}
        options={{
          strokeColor: '#3399FF',
          strokeWeight: 3,
          strokeOpacity: 1,
          defaultVisible: true
        }}
        onClick={onPolyLineClickNotTraveled}
      />

      {/* Create Stop Modal */}
      <Dialog
        open={showCreateStop}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-description-title">
          Create Stop
          {/* Close Button */}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#00000'
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description-desc">
            Create a new Stop at this location?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            size="small"
            className="stops-create-btn-modal"
            onClick={() =>
              requestNewStopCreation(
                createStops?.tripPoints,
                createStops?.emulatorId
              )
            }
            autoFocus
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
